module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0037.jpg?v=5aa6e95c";